<template>
  <div class="banner">
    <div>
      <div>
        <img src="../assets/image/banner.png" />
      </div>
      <div>
        <img src="../assets/image/bannerText.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.banner {
  height: 50vh;
  background: $main-yellow;

  > div {
    display: flex;
    align-items: center;
    padding: 0 100px;
    height: 100%;

    @media (max-width: 1024px) {
      padding: 20px 0 0;
    }

    > div {
      flex: 1;
      padding: 22px 45px;

      @media (max-width: 1024px) {
        padding: 0;
      }

      &:first-child {
        margin-right: 50px;

        @media (max-width: 1024px) {
          margin-right: 0;
        }

        img {
          width: 90%;
        }
      }

      &:nth-child(2) {
        @media (max-width: 768px) {
          display: none;
        }

        img {
          width: 50%;
        }
      }
    }
  }
}
</style>
